export const brandBgIsDefault = {
  type: "boolean"
};
